import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Container } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import HandleHttpErrors from "../../HandleHttpErrors";
import SearchableDropdown from "../../shared/SearchableDropdown";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
//import ModalS from "../../ErrorModal";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ setRefreshMoamads, counter, mekhraz_id, users }) {
  const axiosPrivate = useAxiosPrivate("application/json");
  const [megdarOptions, setMegdarOptions] = useState([]);
  const [famOptions, setFamOptions] = useState([]);
  const [show, toggleShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState("בחר מועמד....");
  const [userEmail, setUserEmail] = useState("");
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getMegdarType = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "megdartype/", {
          signal: controller.signal,
        });
        isMounted && setMegdarOptions(response.data[0].megdarOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getMegdarType();

    const getFamType = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "famtype/", {
          signal: controller.signal,
        });
        isMounted && setFamOptions(response.data[0].famOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getFamType();
  }, []);

  const [newMoamad, setNewMoamad] = useState({
    idz: "",
    f_name: "",
    father_name: "",
    l_name: "",
    birth_date: "",
    megdar: "",
    fam_status: "",
    children_num: 0,
    citizenship: "",
    special_needs: false,
    ethiopian: false,
    arab_droze_circassian: false,
    mobile_phone: "",
    home_phone: "",
    work_phone: "",
    Address: "",
    zipcode: 0,
    moamad_notes: "",
    mekhraz: mekhraz_id,
    user: 0,
  });

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewMoamad((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeSDD = (id, val) => {
    setNewMoamad((prevState) => ({
      ...prevState,
      user: id,
      idz: val,
    }));
  };

  const handleCheckBoxChange = (e) => {
    const { name, value } = e.target;
    setNewMoamad((prevState) => ({
      ...prevState,
      [name]: e.target.checked,
    }));
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setNewMoamad((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const addData = async () => {
      try {
        const response = await axiosPrivate.post("/jobs/moamad/", newMoamad, {
          signal: controller.signal,
        });

        isMounted && setRefreshMoamads((prev) => !prev);
        alert("הוספת המועמד בוצעה בהצלחה");
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    addData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <div>
      <HelpModal />
      <center>
        <br />
        <button className="btn btn-dark" onClick={() => toggleShow(!show)}>
          {show ? "הסתר הוספה" : "הוספת מועמד"}
        </button>
      </center>
      {show && (
        <div className="card text-dark bg-light container p-3 border">
          <center>
            <div className="card-header">
              <h3
                onClick={() => {
                  setSaeef("4");
                  setShowHelp(true);
                }}
              >
                הוספת מועמד חדש
                <span className="help">
                  <MdLiveHelp />
                </span>
              </h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit} className="mbsc-form-group">
                <Container className="col-sm-10">
                  <div>
                    <SearchableDropdown
                      options={users}
                      label="username"
                      id="id"
                      other="email"
                      selectedVal={value}
                      handleChange={(val, id, email) => {
                        setValue(val);
                        setUserEmail(email);
                        handleChangeSDD(id, val);
                      }}
                    />
                  </div>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="f_name">שם פרטי</label>
                        <br />
                        <input
                          type="text"
                          name="f_name"
                          value={newMoamad.f_name}
                          onChange={handleChange}
                          className="form-control"
                          id="f_name"
                          placeholder="תקליד שם מחלקה להוספה"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="father_name">שם אב/אמצעי</label>
                        <br />
                        <input
                          type="text"
                          name="father_name"
                          value={newMoamad.father_name}
                          onChange={handleChange}
                          className="form-control"
                          id="father_name"
                          placeholder="תקליד שם אב או אמצעי"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="l_name">שם משפחה</label>
                        <br />
                        <input
                          type="text"
                          name="l_name"
                          value={newMoamad.l_name}
                          onChange={handleChange}
                          className="form-control"
                          id="l_name"
                          placeholder=""
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="idz">מס תעודת זהות אוטומטי</label>
                        <br />
                        {newMoamad.idz}
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="birth_date">תאריך לידה</label>
                        <br />
                        <input
                          type="date"
                          name="birth_date"
                          value={newMoamad.birth_date}
                          onChange={handleChange}
                          className="form-control"
                          id="birth_date"
                          placeholder=""
                        />
                      </div>
                    </Col>

                    <Col>
                      <div className="form-group">
                        <label htmlFor="megdar">מגדר</label>
                        <br />
                        <select
                          name="megdar"
                          onChange={handleChange}
                          value={newMoamad.megdar}
                          required
                        >
                          <option key="0" value="" selected>
                            בחר סוג
                          </option>
                          {megdarOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="children_num">מספר ילדים</label>
                        <br />
                        <input
                          type="number"
                          name="children_num"
                          value={newMoamad.children_num}
                          onChange={handleChange}
                          className="form-control"
                          id="children_num"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="fam_status">מצב משפחתי</label>
                        <br />
                        <select
                          name="fam_status"
                          onChange={handleChange}
                          value={newMoamad.fam_status}
                          required
                        >
                          <option key="0" value="" selected>
                            בחר מצב משפחתי
                          </option>
                          {famOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="citizenship">אזרחות</label>
                        <br />
                        <input
                          type="text"
                          name="citizenship"
                          value={newMoamad.citizenship}
                          onChange={handleChange}
                          className="form-control"
                          id="citizenship"
                          placeholder=""
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="special_needs">
                          בעל צרכים מיוחדים?
                        </label>
                        <br />
                        <input
                          type="checkbox"
                          id="special_needs"
                          name="special_needs"
                          value={newMoamad.special_needs}
                          onChange={handleCheckBoxChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="arab_droze_circassian">
                          נמנה על האוכלוסיה הערבית, הדרוזית או הצרקסית?
                        </label>
                        <br />
                        <input
                          type="checkbox"
                          id="arab_droze_circassian"
                          name="arab_droze_circassian"
                          value={newMoamad.arab_droze_circassian}
                          onChange={handleCheckBoxChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="ethiopian">אתיופי?</label>
                        <br />
                        <input
                          type="checkbox"
                          id="ethiopian"
                          name="ethiopian"
                          value={newMoamad.ethiopian}
                          onChange={handleCheckBoxChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="mobile_phone">מספר נייד</label>
                        <br />
                        <input
                          type="text"
                          name="mobile_phone"
                          value={newMoamad.mobile_phone}
                          onChange={handleChange}
                          className="form-control"
                          id="mobile_phone"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="mobile_phone">טלפון בעבודה</label>
                        <br />
                        <input
                          type="text"
                          name="work_phone"
                          value={newMoamad.work_phone}
                          onChange={handleChange}
                          className="form-control"
                          id="work_phone"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="home_phone">טלפון בבית</label>
                        <br />
                        <input
                          type="text"
                          name="home_phone"
                          value={newMoamad.home_phone}
                          onChange={handleChange}
                          className="form-control"
                          id="home_phone"
                          placeholder=""
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="Address">כתובת</label>
                        <br />
                        <input
                          type="text"
                          name="Address"
                          value={newMoamad.Address}
                          onChange={handleChange}
                          className="form-control"
                          id="Address"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="zipcode">מיקוד</label>
                        <br />
                        <input
                          type="text"
                          name="zipcode"
                          value={newMoamad.zipcode}
                          onChange={handleChange}
                          className="form-control"
                          id="zipcode"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="userEmail">
                          דואר אלקטרוני-אוטומטי-
                        </label>
                        <br />
                        {userEmail}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <div className="form-group">
                      <label htmlFor="moamad_notes">משהו טוב שרוצה לספר</label>
                      <textarea
                        name="moamad_notes"
                        cols={50}
                        rows={2}
                        value={newMoamad.moamad_notes}
                        onChange={handleChange}
                        className="form-control"
                        id="moamad_notes"
                      />
                    </div>
                  </Row>
                  <button type="submit" className="btn btn-primary">
                    אישור הוספת מועמד חדש
                  </button>
                </Container>
              </form>
            </div>
          </center>
        </div>
      )}
    </div>
  );
}
